// extracted by mini-css-extract-plugin
export default {"thankYouContainer":"ThankYouAlert_thankYouContainer__GQqho","thankYouModal":"ThankYouAlert_thankYouModal__Azxq7","thankYouModalClose":"ThankYouAlert_thankYouModalClose__4SgS1"};